import { useCallback, useState } from '@wordpress/element';
import { calcularNota, estaContido } from './auxiliares';
import { useMetadadosItem } from './useMetadadosItem';

export const useMetadadosAltImagem = () => {
  const criterios = [
    {
      texto: 'O texto alternativo deve conter a palavra-chave',
      otimizado: false,
    },
    {
      texto: 'Este campo não pode estar vazio',
      otimizado: false,
    },
  ];

  function validacoes(index, altImagem, palavraChave) {
    switch (index) {
      case 0:
        return estaContido(palavraChave, altImagem);
      case 1:
        return altImagem !== null && altImagem !== undefined && altImagem.length > 0;
    }
  }

  return useMetadadosItem({ itemCriterios: criterios, validacoesFn: validacoes });
};
